/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { Flex, Heading } from "@chakra-ui/react";
import "./styles.scss";
import { Loader } from "@progress/kendo-react-indicators";

export default function FilterBar({ heading, children, showLoader }) {
  return (
    <Flex className="filter-row" align="center">
      <Heading className="heading-2" style={{ marginBottom: 0 }}>
        {heading}
      </Heading>
      <Flex flexDirection="row" align="center">
        {showLoader ? <Loader size="large" type="pulsing" /> : <></>}{" "}
        <Flex className="filters-inner-row">{children}</Flex>
      </Flex>
    </Flex>
  );
}
